import { createAction, props } from '@ngrx/store';
import { PartData } from '@shared/gui/models/part-data.model';
import { ExportConfig } from '../models/chart-export.model';
import { ClosedPath, GraphConfig, GraphTolerance } from '../models/graph.model';
import { PathElement } from '../models/path-element.model';
import { PathGasBlock } from '../models/path-gas-block.model';
import { GraphPanel } from './gas-block.reducer';
import { PathGraphResponse } from '../models/path-request.model';
import { FavoritePath } from '../models/favorite-path.model';
import { OriginPathGasBlock } from '../models/origin-gas-block.model';

// init

export const loadFavoritePathsSuccess = createAction(
  '[Settings] Load favorite paths success',
  props<{ favoritePaths: Array<FavoritePath> }>()
);
export const loadFavoritePathsError = createAction('[Settings] Load favorite paths failure');

// core

export const resetState = createAction('[GasBlock] Reset state instruction');
export const resetStateApply = createAction('[GasBlock] Apply reset state once preprocess is done');

export const selectParts = createAction('[GasBlock] Select parts for pathfinding', props<{ parts: Array<PartData> }>());
export const reorderParts = createAction(
  '[GasBlock] Reorder parts for pathfinding',
  props<{ parts: Array<PartData> }>()
);

export const orderParts = createAction('[GasBlock] Order parts for pathfinding', props<{ parts: Array<PartData> }>());
export const savePathPoints = createAction(
  '[GasBlock] Save the path points for reordering',
  props<{ parts: Array<PartData> }>()
);

export const init = createAction(
  '[GasBlock] Init path and gas blocks',
  props<{ path: Array<string>; elements: Array<PathElement>; gasBlocks: Array<PathGasBlock> }>()
);
export const update = createAction(
  '[GasBlock] Update path with new gas blocks',
  props<{ elements: Array<PathElement>; gasBlocks: Array<PathGasBlock>; closedPaths: Array<ClosedPath> }>()
);

export const selectDisplay = createAction(
  '[GasBlock] Choose de display mode for gas blocks',
  props<{ display: GraphPanel }>()
);

export const selectConfig = createAction(
  '[GasBlock] Choose de configuration for gas blocks chart',
  props<{ config: GraphConfig }>()
);

export const setTolerances = createAction(
  '[GasBlock] Set the tolerance limit for current property',
  props<{ tolerances: Array<GraphTolerance> }>()
);
export const setBlockTolerance = createAction(
  '[GasBlock] Set the tolerance limit for gas blocks',
  props<{ tolerance: GraphTolerance }>()
);

export const initExport = createAction('[GasBlock] Init export with options', props<{ config: ExportConfig }>());
export const resultExport = createAction(
  '[GasBlock] load export data from back',
  props<{ data: Array<PathGraphResponse> }>()
);
export const endExport = createAction('[GasBlock] End the export process');

// Favorite Path
export const displayFavoritePath = createAction(
  '[GasBlock] Display the wished favorite path',
  props<{ favoritePath: FavoritePath }>()
);
export const selectFavoritePath = createAction(
  '[GasBlock] Select the favorite path parts',
  props<{ parts: Array<PartData> }>()
);

// Source Path
export const displaySourcePath = createAction(
  '[GasBlock] Display the wished source path',
  props<{ sourcePath: Array<string> }>()
);
export const selectSourcePath = createAction(
  '[GasBlock] Select the source path parts',
  props<{ parts: Array<PartData> }>()
);

export const displayOnlyPath = createAction(
  '[GasBlock] Display only path',
  props<{ displayOnlyPath: boolean; updateAlarm?: boolean }>()
);

export const getLastOriginGasBlockSuccess = createAction(
  '[GasBlock] Get gas block origins',
  props<{ lastOriginGasblock: OriginPathGasBlock }>()
);

export const setDisplayOnlyPathOrigin = createAction(
  '[GasBlock] Display only path origin',
  props<{ displayOnlyPathOrigin: boolean }>()
);
